import type { ApiHttpClient } from '../client/http.client'
import type { Spoon } from '../client/spoon.client'
import { User, UserCurrentLive } from '../struct/user.struct'

export class UserApi {
  constructor(
    private http: ApiHttpClient,
    private spoon: Spoon
  ) {}

  getUserInfo(id: number) {
    return this.http.request(
      `/users/${id}`,
      {
        method: 'GET'
      },
      User
    )
  }

  getFollowings(id: number, nickname?: string) {
    return this.http.request(
      `/users/${id}/followings`,
      {
        method: 'GET',
        params: {
          ...(nickname ? { nickname } : {})
        }
      },
      User
    )
  }

  getFollowers(id: number, nickname?: string) {
    return this.http.request(
      `/users/${id}/followers`,
      {
        method: 'GET',
        params: {
          ...(nickname ? { nickname } : {})
        }
      },
      User
    )
  }

  getCurrentLive(id: number) {
    return this.http.request(
      `/users/${id}/live`,
      {
        method: 'GET'
      },
      UserCurrentLive
    )
  }
}
